export class downloadFileModel {
  
    constructor(
      public mail: string,
      public passw: string,
      public order_id: string,
      public filename: string
    ) {  }
  
  }


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/downloadFileModel.ts